import C from "../actionTypes";
import config from "../../config/config";
import gbParams from "../../config/parameters";

export const clubsData = (state = [], action) => {
    switch (action.type) {

        case C.CLUBS_SUCCESS:
            return action.clubsData;

        // case C.CREATE_CLUB_SUCCESS:
        //     return [...state, ...action.clubData];

        case C.CLUBS_INFO_SUCCESS:
            let newClubList = [];
            for (let club of state) {
                if (!!action.clubsData[club.clubId]) {
                    const { description, level, levelExpiration: levelExp } = action.clubsData[club.clubId];
                    newClubList.push({ ...club, description, level, levelExp });
                } else {
                    newClubList.push(club);
                }
            }
            return newClubList;

        // case C.DISBAND_CLUB_SUCCESS:
        //     return state.filter(club => club.clubId != action.clubId);
        default:
            return state;
    }
};

const increaseBalance = (ws, amount) => ws.map(w => w.currency !== ws[0].currency ? w : { ...w, balance: w.balance + amount });
const decreaseBalance = (ws, amount) => ws.map(w => w.currency !== ws[0].currency ? w : { ...w, balance: w.balance - amount });

export const currentClub = (state = {}, action) => {
    switch (action.type) {
        case C.CURRENT_CLUB_SUCCESS:
            return action.currentClub;
        case C.RESET_CURRENT_CLUB:
            return {};
        case C.CHANGE_CLUB_SUCCESS:
            return {...state, description: action.description};
        case C.CREATE_UNION_SUCCESS:
            return {...state, union: action.union};
        case C.AGENT_TRANSACTION_REQUEST: {
            const fromClub = action.to === action.agentId;
            return {
                ...state,
                adminAccount: {
                    ...state.adminAccount,
                    wallets: fromClub ?
                        decreaseBalance(state.adminAccount.wallets, action.amount) :
                        increaseBalance(state.adminAccount.wallets, action.amount),
                },
            };
        };
        case C.REFRESH_ACCOUNT_BALANCE_REQUEST: {
            return {...state, isLoading: true};
        };
        case C.REFRESH_ACCOUNT_BALANCE_SUCCESS: {
            return {
                ...state,
                playerAccount: {
                    ...state.playerAccount,
                    wallets: action.updatedBalance
                },
                isLoading: false
            };
        };
        default:
            return state;
    }
};

export const clubTransfers = (state = [], action) => {
    switch (action.type) {
        case C.CLUB_TRANSFERS_SUCCESS:
            return action.transfers;
        default:
            return state;
    }
};

const gameTransfersInitial = {pending: false, transfers: []} 
export const gameTransfers = (state = gameTransfersInitial, action) => {
    switch (action.type) {
        case C.GAME_TRANSFERS_REQUEST:
            return { ...state, pending: true };
        case C.GAME_TRANSFERS_SUCCESS:
            return { ...state, transfers: action.transfers, pending: false };
        case C.GAME_TRANSFERS_FAILURE:
            return { ...state, pending: false };
        default:
            return state;
    }
};

export const currentClubMembers = (state = [], action) => {
    switch (action.type) {
        case C.CURRENT_CLUB_MEMBERS_SUCCESS:
            return action.members;
        case C.RESET_CURRENT_CLUB:
            return [];
        default:
            return state;
    }
};

export const leagueMenu = (state = true, action) => {
    switch (action.type) {
        case C.TOGGLE_LEAGUE_MENU:
            return !state;
        default:
            return state;
    }
};

export const clubData = (state = {}, action) => {
    switch (action.type) {
        case C.CLUB_DATA_SUCCESS: {
            const { clubId, data } = action;
            return { ...state, [clubId]: data };
        } default:
            return state;
    }
}

export const clubPokerFrames = (state = {}, action) => {
    switch (action.type) {
        case C.INIT_POKER_FRAME: {
            const { clubId } = action;
            if( !state[clubId] ) {
                return { ...state, [clubId]: {status: gbParams.pokerLobbyStates.NONE, wnd: null} };
            }
            return state;
        }
        case C.ALTER_POKER_FRAME: {
            const { clubId, params } = action;
            const clubFrame = !!state[clubId] ? state[clubId] : {};
            return { ...state, [clubId]: {...clubFrame, ...params} };
        }
        case C.USER_LOGOUT:
            return {};
        default:
            return state;
    }
}

export const clubProducts = (state = {}, action) => {
    switch (action.type) {
        case C.CLUB_PRODUCTS_SUCCESS: {
            return {...state, [action.clubId]: action.prods};
        }
        default:
            return state;
    }
}

export const selectedTab = (state = '', action) => {
    switch (action.type) {
        case C.CREATE_TABLE_SUCCESS:
            return  "poker";
        case C.LEAVE_CLUB:
            return  "";
        case C.SET_GAME_CATEGORY:
            return action.selected;
        default:
            return state;
    }
}